import { motion } from 'framer-motion';
import { useInView } from '../../../hooks/useInView';

const TrustIndicators = () => {
  const [ref, isInView] = useInView({ threshold: 0.3 });

  const stats = [
    { number: '30+', label: 'Years Combined', sublabel: 'Industry Experience' },
    { number: '5,000+', label: 'Global Manufacturing', sublabel: 'Partners' },
    { number: '156', label: 'Countries', sublabel: 'Served Worldwide' },
    { number: '$500M+', label: 'Projects', sublabel: 'Delivered' },
  ];

  return (
    <section ref={ref} className="bg-gray-50 py-12">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ delay: index * 0.1, duration: 0.6 }}
              className="text-center"
            >
              <div className="font-display font-bold text-4xl md:text-5xl bg-gradient-to-r from-primary-600 to-secondary-600 text-transparent bg-clip-text mb-2">
                {stat.number}
              </div>
              <div className="text-sm font-semibold text-gray-900">{stat.label}</div>
              <div className="text-xs text-gray-600 mt-1">{stat.sublabel}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustIndicators;